import React from 'react';
import { createFrontendPlugin, PageBlueprint } from '@backstage/frontend-plugin-api';

const spaceManagerPage = PageBlueprint.make({
  params: {
    path: '/space-manager',
    loader: () =>
      import('./SpaceManagerPage').then(m =>
        React.createElement(m.SpaceManagerPage),
      ),
  },
});

export const spaceManagerPlugin = createFrontendPlugin({
  pluginId: 'space-manager',
  extensions: [spaceManagerPage],
});
